export default "__VITE_ASSET__BncbT2Bg__"